import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Avatar from '../Avatar';
import { UserCard } from '../Card';
import Notifications from '../Notifications';
import SearchInput from '../SearchInput';
import { notificationsData } from '../../demos/header';
import withBadge from '../../hocs/withBadge';
import {
    MdClearAll,
    MdExitToApp,
    MdHelp,
    MdInsertChart,
    MdMessage,
    MdNotificationsActive,
    MdNotificationsNone,
    MdPersonPin,
    MdSettingsApplications,
} from 'react-icons/md';
import {
    Button,
    ListGroup,
    ListGroupItem,
    // NavbarToggler,
    Nav,
    Navbar,
    NavItem,
    NavLink,
    Popover,
    PopoverBody,
} from 'reactstrap';
import bn from '../../utils/bemnames';
// config
import { removeAuthorization } from '../../config/axios';
// import reducers
import { removeAuthAccount } from '../../redux/reducers/auth';
// lib
import toastAlert from '../../lib/toastAlert';
const bem = bn.create('header');

const MdNotificationsActiveWithBadge = withBadge({
    size: 'md',
    color: 'primary',
    style: {
        top: -10,
        right: -10,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    children: <small>5</small>,
})(MdNotificationsActive);

const initialState = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false
}

const Header = () => {

    // hooks
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { email, name } = useSelector((state) => state.profile);
    // state
    const [state, setState] = useState(initialState);
    const {
        isOpenNotificationPopover,
        isNotificationConfirmed,
        isOpenUserCardPopover
    } = state;

    const toggleNotificationPopover = () => {
        let formData = { ...state, ...{ isOpenNotificationPopover: !isOpenNotificationPopover } }
        if (!isNotificationConfirmed) {
            formData = { ...formData, ...{ isNotificationConfirmed: true } }
        }
        setState(formData)
    };

    const toggleUserCardPopover = () => {
        setState({ ...state, ...{ isOpenUserCardPopover: !isOpenUserCardPopover } })
    };

    const handleSidebarControlButton = event => {
        event.preventDefault();
        event.stopPropagation();
        document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
    };

    const handleLogout = () => {
        removeAuthorization();
        toastAlert('success', 'Logout Successfully', 'logout')
        removeAuthAccount(dispatch)
        navigate('/login')
    }

    const navigatePath = (path) => {
        toggleUserCardPopover()
        navigate(path)
    }

    return (
        <Navbar light expand className={bem.b('bg-white')}>
            <Nav navbar className="mr-2">
                <Button outline onClick={handleSidebarControlButton}>
                    <MdClearAll size={25} />
                </Button>
            </Nav>
            <Nav navbar>
                <SearchInput />
            </Nav>

            <Nav navbar className={bem.e('nav-right')}>
                {/* <NavItem className="d-inline-flex">
                    <NavLink id="Popover1" className="position-relative">
                        {
                            isNotificationConfirmed ? (
                                <MdNotificationsNone
                                    size={25}
                                    className="text-secondary can-click"
                                    onClick={toggleNotificationPopover}
                                />
                            ) : (
                                <MdNotificationsActiveWithBadge
                                    size={25}
                                    className="text-secondary can-click animated swing infinite"
                                    onClick={toggleNotificationPopover}
                                />
                            )
                        }
                    </NavLink>
                    <Popover
                        placement="bottom"
                        isOpen={state.isOpenNotificationPopover}
                        toggle={toggleNotificationPopover}
                        target="Popover1"
                    >
                        <PopoverBody>
                            <Notifications notificationsData={notificationsData} />
                        </PopoverBody>
                    </Popover>
                </NavItem> */}

                <NavItem>
                    <NavLink id="Popover2">
                        <Avatar
                            onClick={toggleUserCardPopover}
                            className="can-click"
                        />
                    </NavLink>
                    <Popover
                        placement="bottom-end"
                        isOpen={state.isOpenUserCardPopover}
                        toggle={toggleUserCardPopover}
                        target="Popover2"
                        className="p-0 border-0"
                        style={{ minWidth: 250 }}
                    >
                        <PopoverBody className="p-0 border-light">
                            <UserCard
                                title={name}
                                subtitle={email}
                                text=""
                                className="border-light"
                            >
                                <ListGroup flush>
                                    {/* <ListGroupItem tag="button" action className="border-light" onClick={() => navigatePath('/profile')}>
                                        <MdPersonPin /> Profile
                                    </ListGroupItem> */}
                                    <ListGroupItem tag="button" action className="border-light" onClick={() => navigatePath('/tfa')}>
                                        <MdInsertChart /> TFA
                                    </ListGroupItem>
                                    {/* <ListGroupItem tag="button" action className="border-light">
                                        <MdMessage /> Messages
                                    </ListGroupItem>
                                    <ListGroupItem tag="button" action className="border-light">
                                        <MdSettingsApplications /> Settings
                                    </ListGroupItem>
                                    <ListGroupItem tag="button" action className="border-light">
                                        <MdHelp /> Help
                                    </ListGroupItem> */}
                                    <ListGroupItem tag="button" action className="border-light" onClick={handleLogout}>
                                        <MdExitToApp /> Logout
                                    </ListGroupItem>
                                </ListGroup>
                            </UserCard>
                        </PopoverBody>
                    </Popover>
                </NavItem>
            </Nav>
        </Navbar>
    );
}

export default Header;
